/* eslint-disable no-nested-ternary */
const getUsableWidth = (sideMenuOpen: boolean, isMobile: boolean): string =>
  sideMenuOpen && !isMobile
    ? "calc(100% - 270px)"
    : isMobile
    ? "calc(100% - 20px)"
    : "calc(100% - 70px)";

export default getUsableWidth;
